/* eslint-disable import/prefer-default-export */
import { t } from 'i18next';
import getCountryFromTld from './country-from-tld';

const COUNTRY_COMPLIANCE_CONFIG = {
  Mexico: {
    shouldValidateCompliance: true,
    validateCompliance: (complianceStatus) => (
      complianceStatus.debtorApproved === true
      && complianceStatus.withinAvailableDays === true
      && complianceStatus.hasPaymentComplement === false
    ),
    getNonComplianceReasons: (complianceStatus) => {
      const reasons = [];
      if (complianceStatus.debtorApproved === false) {
        reasons.push('Deudor no aprobado');
      }
      if (complianceStatus.withinAvailableDays === false) {
        reasons.push('Emisión mayor a 30 días');
      }
      if (complianceStatus.hasPaymentComplement === true) {
        reasons.push('Tiene complemento de pago');
      }
      if (complianceStatus.rugInscribed === true) {
        reasons.push('Inscrita en RUG');
      }
      return reasons;
    },
  },
  Chile: {
    shouldValidateCompliance: false,
    validateCompliance: () => true,
    getNonComplianceReasons: () => [],
  },
};

export const preofferCacheStatusToText = (row) => {
  /* row must be InvoiceType */
  const status = row.preofferSelectable?.status;
  const isSelectable = row.preofferSelectable?.selectable;
  const { loanedTo } = row;
  const loandedMessage = loanedTo ? `Cedida a ${loanedTo}` : 'Cedida a otro factoring';
  return {
    EVALUATING: 'En evaluación',
    REJECTED: 'Rechazada en evaluación',
    REJECTEDPREOFFEREVALUATION: 'Eval. de preoferta rechazada',
    PENDINGDOCUMENTSEXPIRED: 'Expirada en pendiente de documentos',
    DOCUMENTSREVIEWEXPIRED: 'Expirada en pendiente de documentos',
    PENDINGDOCUMENTS: 'Pendiente de documentos',
    DOCUMENTSREVIEWED: 'Factura en evaluación',
    LOANED: loandedMessage,
    HAS_CREDIT_NOTE: 'Con nota de crédito total',
    HAS_PAYMENTS_EMITTED: 'Pagos emitidos',
    PROCESSING: 'Enviando',
    REJECTED_BY_SII: `Rechazado por el ${t('National Tax Service acronym')}`,
    REJECTED_RECEIVER: 'Rechazado por receptor',
    REJECTED_CONTENT: 'Con reclamos al contenido',
    REJECTED_FOR_CONTENT: 'Rechazado por falta de contenido',
    REJECTED_FOR_TOTAL: 'Rechazado por falta total de mercadería',
    REJECTED_FOR_PARTIAL: 'Rechazado por falta parcial de mercadería',
    VALID: isSelectable ? 'Disponible' : null,
    IS_CREDIT_NOTE: 'Es una nota de crédito',
    IS_DEBIT_NOTE: 'Es una nota de débito',
    IS_PAYMENT: 'No financiable por ser factura de pago',
    RECEPTION_ACKNOWLEDGED: 'Disponible, con acuse de recibo',
    PARTIAL_CLAIM: 'Reclamo parcial de mercadería',
    TOTAL_CLAIM: 'Reclamo total de mercadería',
    ALREADY_PAYED: 'Pagado al contado',
    INVALID_STATUS: null,
    UNKNOWN_STATUS: null,
    EXPIRED: 'Factura vencida',
    HAS_OFFER: 'Con oferta',
    HAS_OPERATION: 'Operada',
    IS_FOR_ORDERING: 'Para pago de OC',
    OFFERED: 'Con oferta',
    NOT_AVAILABLE: 'No disponible',
    FUTURE: 'Factura con fecha emisión futura',
    PENDING_RISK_EVALUATION: 'Evaluación de riesgo pendiente',
  }[status] || null;
};

const isInvoiceCompliant = (row) => {
  const country = getCountryFromTld();
  const config = COUNTRY_COMPLIANCE_CONFIG[country] || COUNTRY_COMPLIANCE_CONFIG.Chile;

  if (!config.shouldValidateCompliance) return true;

  const { complianceStatus } = row;
  if (!complianceStatus) return false;

  return config.validateCompliance(complianceStatus);
};

export const getNonComplianceReasons = (row) => {
  const country = getCountryFromTld();
  const config = COUNTRY_COMPLIANCE_CONFIG[country] || COUNTRY_COMPLIANCE_CONFIG.Chile;

  if (!config.shouldValidateCompliance) return [];

  const { complianceStatus } = row;
  if (!complianceStatus) return ['Estado de cumplimiento no disponible'];

  return config.getNonComplianceReasons(complianceStatus);
};

export const preofferSimplifiedStatusToText = (row) => {
  const status = row.preofferSelectable?.status;
  const isSelectable = row.preofferSelectable?.selectable;
  const evaluationRequest = row.preoffer?.preofferevaluationrequest;

  if (!isInvoiceCompliant(row)) {
    return 'No financiable';
  }

  if (!isSelectable && !evaluationRequest) {
    return 'No financiable';
  }
  return {
    VALID: 'Financiable',
    RECEPTION_ACKNOWLEDGED: 'Financiable, con acuse de recibo',
    INVALID_STATUS: 'Financiable',
    UNKNOWN_STATUS: 'Financiable',
    EVALUATING: 'Factura en evaluación',
    REJECTED: 'Factura rechazada',
    HAS_OFFER: 'Factura aprobada',
    OFFERED: 'Factura aprobada',
    PENDINGDOCUMENTS: 'Factura pendiente de documentos',
    DOCUMENTSREVIEWED: 'Factura en evaluación',
  }[status] || 'No financiable';
};
